(function GroupRegistrationManifest($, Adzuki)
{
	"use strict";

	Adzuki.onload('GroupRegistrations/registrationReports/', init, false);

	function init()
	{
		$('#view-manifest').on('click', viewRegistrationManifest);
	}

	function viewRegistrationManifest()
	{
		var registration_id = $('#groupregistrationexport-registration_id').val().trim();

		if (registration_id === '') {
			Adzuki.StatusMessage(null, 'You must select a Primary Passenger.', 'Passenger Required');
		} else {
			window.open(Adzuki.base_uri + '/GroupRegistrations/viewManifest/' + registration_id);
		}
	}

}(jQuery, window.Adzuki || {}));